import React from "react";
import { motion } from "framer-motion";
import { FiArrowUpRight, FiHome, FiChevronRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import { openConsultationMail } from "../config/contact";

const ServicePageHero = ({ title, subtitle, breadcrumb, image, badge }) => {
  // Parse breadcrumb string "Home > Services > SEO" into links
  const parts = breadcrumb ? breadcrumb.split(">").map(p => p.trim()) : [];
  const crumbLinks = {
    "Home": "/",
    "Services": "/services",
    "About Us": "/about",
    "Our Blog": "/blog",
    "Contact Us": "/contact",
    "SEO": "/seo-services-delhi-ncr",
    "PPC Advertising": "/ppc-services-delhi-ncr",
    "Social Media": "/social-media-marketing-delhi-ncr",
    "Web Design": "/website-design-development-delhi-ncr",
    "Ecommerce": "/ecommerce-services-delhi-ncr",
    "Content Marketing": "/content-marketing-services-delhi-ncr",
    "Email Marketing": "/email-marketing-services-delhi-ncr",
  };

  return (
    <>
      <section className="svc-hero">
        <div className="svc-hero-inner">
          <motion.div className="svc-hero-left" initial={{ opacity: 0, x: -40 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.7, ease: "easeOut" }}>
            {badge && <span className="svc-hero-badge">{badge}</span>}
            <h1>{title}</h1>
            <p className="svc-hero-sub">{subtitle}</p>
            <div className="svc-hero-actions">
              <button className="btn-primary" onClick={openConsultationMail}>
                Get Free Consultation
                <span className="hero-btn-arrow"><FiArrowUpRight /></span>
              </button>
            </div>
            {/* Clickable breadcrumb */}
            <nav className="svc-hero-breadcrumb" aria-label="breadcrumb">
              {parts.map((part, i) => (
                <span key={i} className="svc-crumb">
                  {i > 0 && <FiChevronRight className="svc-crumb-sep" />}
                  {crumbLinks[part] ? (
                    <Link to={crumbLinks[part]}>{i === 0 && <FiHome />} {part}</Link>
                  ) : (
                    <span>{part}</span>
                  )}
                </span>
              ))}
            </nav>
          </motion.div>

          <motion.div className="svc-hero-right" initial={{ opacity: 0, x: 40 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.7, delay: 0.15, ease: "easeOut" }}>
            <div className="svc-hero-img-wrap svc-hero-img-wrap--square">
              <img src={image} alt={title} className="svc-hero-img-square" />
              <motion.div className="svc-hero-deco-star" animate={{ y: [0, -10, 0] }} transition={{ duration: 3.5, repeat: Infinity, ease: "easeInOut" }}>✷</motion.div>
              <motion.div className="svc-hero-deco-plus" animate={{ y: [0, 8, 0] }} transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}>+</motion.div>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default ServicePageHero;
